import React from 'react';
import { Result, Button } from 'antd';
import { DesktopOutlined } from '@ant-design/icons';

interface MobileGuardProps {
  children: React.ReactNode;
  allowMobile?: boolean;
}

const MobileGuard: React.FC<MobileGuardProps> = ({ children, allowMobile = false }) => {
  if (allowMobile) {
    return <>{children}</>;
  }

  return (
    <>
      <div className="mobile-only">
        <Result
          icon={<DesktopOutlined />}
          title="PC・タブレットでご利用ください"
          subTitle="この画面はPC・タブレットに最適化されています。ダッシュボードはモバイルからもご覧いただけます。"
          extra={
            <Button type="primary" onClick={() => window.location.href = '/app/dashboard'}>
              ダッシュボードへ
            </Button>
          }
        />
      </div>
      <div className="desktop-only">
        {children}
      </div>
    </>
  );
};

export default MobileGuard;
